import { jsx as _jsx } from "react/jsx-runtime";
import { ComputerFileUploadUpsellBoundary } from '#pplx/frontend/apps/ask/computer-file-upload-upsell/ComputerFileUploadUpsellBoundary.js';
import { useCallback } from 'react';
/**
 * Connects completed Composer uploads to Ask's existing Computer upload affordance.
 * Eligibility, copy, and mode-switch policy remain in the product boundary.
 *
 * @returns The Computer toggle renderer backed by the existing upload boundary.
 */
export function useAskComposerUploadAffordance({ attachments, surface, }) {
    return useCallback(({ toggle, onSelectComputer, searchMode }) => (_jsx(ComputerFileUploadUpsellBoundary, { attachments: attachments, onUseComputer: onSelectComputer, searchMode: searchMode, surface: surface, children: toggle }, "computer-file-upload-mode-toggle")), [attachments, surface]);
}
//# sourceMappingURL=useAskComposerUploadAffordance.js.map